export default __webpack_public_path__ + "static/media/customerSupport_icon_2.3394ea21.svg";